import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { CreditCard } from "lucide-react";
import { useChartTheme } from "@/shared/hooks/useChartTheme";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { currentBalanceConfig } from "./data";

export function CurrentBalance() {
  const config = currentBalanceConfig;
  const { inactive } = useChartTheme();
  const { t } = useTranslation();

  const segments = [
    { value: 72, color: "#13c2c2" },
    { value: 28, color: inactive },
  ];

  return (
    <div className={`card-shadow rounded-2xl ${config.bg} p-5`}>
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <div className="flex items-center gap-2.5">
            <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${config.iconBg}`}>
              <CreditCard size={16} className={config.iconColor} strokeWidth={1.75} />
            </div>
            <p className="text-sm font-medium text-muted-foreground">{t.crm.currentBalance}</p>
          </div>
          <p className="mt-3 text-2xl font-bold text-foreground">{config.value}</p>
          <p className={`mt-0.5 text-xs font-medium ${config.changeColor}`}>{t.crm.changeBalance}</p>
        </div>
        <div className="w-[90px] shrink-0">
          <ResponsiveContainer width={70} height={70}>
            <PieChart>
              <Pie data={segments} cx="50%" cy="50%" innerRadius={22} outerRadius={32} startAngle={90} endAngle={-270} dataKey="value" stroke="none">
                {segments.map((entry, i) => (
                  <Cell key={i} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
